import React from "react";
import { FieldLabel, inputClass } from "./FieldLabel";

export function DateTimeField({
  label, value, onChange, required,
}: {
  label: string;
  value: string;            // datetime-local string ("YYYY-MM-DDTHH:mm")
  onChange: (v: string) => void;
  required?: boolean;
}) {
  return (
    <div>
      <FieldLabel required={required}>{label}</FieldLabel>
      <input
        type="datetime-local"
        value={value ? value.slice(0, 16) : ""}
        onChange={e => onChange(e.target.value)}
        className={inputClass}
      />
    </div>
  );
}
